/**
 * WriteBlockedBanner (R0.3)
 *
 * Persistent top-of-AppShell banner shown when the tenant's billing is expired
 * or write-blocked. Displays a non-dismissable alert so the user always sees
 * the read-only state. Navigation and reading remain fully functional.
 */
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';

interface WriteBlockedBannerProps {
  visible: boolean;
}

export function WriteBlockedBanner({ visible }: WriteBlockedBannerProps) {
  if (!visible) return null;

  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: (theme) => theme.zIndex.appBar + 1 }}>
      <Alert
        severity="error"
        variant="filled"
        sx={{
          borderRadius: 0,
          py: 0.75,
          '& .MuiAlert-message': { width: '100%', textAlign: 'center' },
        }}
      >
        <AlertTitle sx={{ mb: 0, display: 'inline', mr: 1 }}>Modalità sola lettura.</AlertTitle>
        Abbonamento scaduto: scrittura disabilitata. Contatta l&apos;amministratore.
      </Alert>
    </Box>
  );
}
